import { UserAvatar } from "../User/UserAvatar";
import { selectShow } from "../../app/selectors";
import { SearchBar } from "../Navigation/SearchBar";
import styles from "../styles/header.module.scss";
import { useI18n } from "../../features/i18n/useI18n";
import { MenuToggle } from "./MenuToggle";
import { useSelector } from "react-redux";
import { setItem } from "../../features/authentication/utils/handleLocalStorage";
import { ThemeToggle } from "../UI";

export const Header = () => {
  const { i18n } = useI18n();
  const show = useSelector(selectShow);

  const handlerChangeLanguage = (language: string) => {
    setItem('language', language);
    i18n.changeLanguage(language);
  };

  return (
    <header className={styles.headerSticky}>
      <div className={styles.headerContent}>
        {/* Izquierda: Logo, Botón crear y menú */}
        <div className={styles.headerLeft}>
          <span className={styles.logoText}>Kairos</span>
          <button className={styles.createButton}>
            <span className={styles.createButtonIcon}>+</span> Crear
          </button>
          <MenuToggle data-type="dark" hidden={show} />
        </div>
        {/* Centro: Buscador */}
        <div className={styles.headerCenter}>
          <SearchBar />
        </div>
        {/* Derecha: Acciones */}
        <div className={styles.headerRight}>
          <div className={styles.headerLangs}>
            <button tabIndex={0} className={styles.header__translate__button} onClick={() => handlerChangeLanguage('en')}>EN</button>
            <button tabIndex={0} className={styles.header__translate__button} onClick={() => handlerChangeLanguage('es')}>ES</button>
          </div>
          <ThemeToggle variant="button" size="sm" />
          <UserAvatar />
        </div>
      </div>
    </header>
  );
};
